export const CAREER_DOMAIN = 'CareerSite.accenture.experium.ru';
export const REFERRAL_DOMAIN = 'EmployeeReferral.accenture.experium.ru';
